import React from "react";
import { Text } from "@catchoftheday/cg-components";
import { date, formatPrice } from "@catchoftheday/utilities";
import { ONEPASS_DISNEY_PLUS_BUNDLE_MONTHLY_PRICE } from "../../../consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Disclaimer = function Disclaimer() {
  var thisYear = date.format(new Date(), "yyyy");
  return ___EmotionJSX(Text, {
    m: 0,
    fontSize: "2xs",
    color: "darkGrey",
    textAlign: {
      xs: "center",
      lg: "left"
    }
  }, "*Eligible items or orders. Exclusions, T&Cs apply", ___EmotionJSX("br", null), ___EmotionJSX("sup", null, "^"), "Savings compared to separately purchasing monthly OnePass memberships and Disney+ Premium monthly subscriptions. Eligibility criteria apply. After the free period, bundle auto-renews at the then-current monthly retail price (currently", " ", formatPrice(ONEPASS_DISNEY_PLUS_BUNDLE_MONTHLY_PRICE), ") until cancelled. Offer valid until 11.59pm on 30 September 2024, unless withdrawn or extended. See T&Cs for full details. \xA9 ", thisYear, " Disney and related entities \xA9 OnePass ", thisYear, ".");
};